import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetDesignations = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/designations/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load designations.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetActiveDesignations = GetDesignations;

export const CreateDesignation = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/designations`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create designation.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateDesignation = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/designations/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update designation.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteDesignation = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/designations/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete designation.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
